// 商品模块（会议，课程，图书）
import zwitCore from "./config/http";
const BASE_URL = process.env.NODE_ENV === "development" ? "/apis" : "";

export default {
  // 1、商品会议详情 （老数据调原先接口传会议id，查询详情；新商品会议传goodsId查询详情）
  meetingDetailsByGoodsId(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleGoods/nf/getMeetingDetailByGoodsId",
      data,
      false
    );
  },
  // 根据会议id查询会议详情 /articleGoods/nf/getMeetingDetail
  meetingDetailsById(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleGoods/nf/getMeetingDetail",
      data,
      false
    );
  },
  // 2.会议报名 提交报名人表单信息
  meetingMemberSignUp(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-information/articleGoods/meetingSignUp",
      data,
      false
    );
  },
  checkMeetingMember(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-information/articleGoods/meetingSignUpBeforeCheck",
      data,
      false
    );
  },

  // 3、图书详情
  bookDetails(data) {
    return zwitCore.HTTP.get(
      BASE_URL +
        "/zw-information/articleGoods/nf/getMonographDetailVoByGoodsId",
      data,
      false
    );
  },
  // 3、图书详情
  courseDetails(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleGoods/nf/getCurriculumDetailByGoodsId",
      data,
      false
    );
  },
  // 根据videoId获取单个阿里云播放地址
  getPlayInfo(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/ali/getPlayInfo",
      data,
      false
    );
  },
  // 根据videoIds获取多个阿里云播放地址
  getPlayInfos(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/ali/getPlayInfos",
      data,
      false
    );
  },
  //获取行业报告行业类型一级列表
  getReportClassifyOneList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-admin/sys/system/getIndustryOneList",
      data,
      false
    );
  },
  // 获取行业报告行业类型二级列表
  getReportClassifyTwoList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-admin/sys/system/getIndustryListByPid",
      data,
      false
    );
  },
  // 出品机构列表
  getProductionOrgAll(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-goods/goodsAttribute/nf/selectProductionOrgAll",
      data,
      false
    );
  },
  // 获取行业报告详情
  getReportDetail(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-goods/goods/nf/selectGoodsInfoById",
      data,
      false
    );
  },

  // 获取行业报告下载资料文件
  getReportFile(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-goods/goods/nf/getFileResourceByGoodsIdAndUserId",
      data,
      false
    );
  },

  // 查询会议论文是否能够购买
  checkPaperGoods(data) {
    return zwitCore.HTTP.post(
      BASE_URL + `/zw-information/articleThesis/buyCheck/${data}`,
      {},
      false
    );
  },

  // 会议论文集详情
  getCollectedDetail(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + `/zw-information/articleThesisCollect/getInfo`,
      data,
      false
    );
  },
  // 会议论文集详情列表
  getCollectedDetailList(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + `/zw-information/articleThesis/pageMeetingThesis/${data.id}`,
      data,
      false
    );
  },
  // 会议详情会议论文列表
  getMeetingDetailPaperList(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL +
        `/zw-information/articleThesis/pageMeetingThesisByBId/${data.id}`,
      data,
      false
    );
  },
  // 根据会议ID获取合作期刊
  getMeetingPeriodicals(meetingId) {
    return zwitCore.HTTP.get(
      BASE_URL +
        `/zw-information/articleMeetingPeriodical/selectVo/${meetingId}`,
      {},
      false
    );
  },
  // 根据期刊ID获取采编
  queryEditorial(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-chat/editing_card/page",
      data,
      false
    );
  },
  // 根据会议ID获取报名表单
  meetingFormTem(goodsId) {
    return zwitCore.HTTP.get(
      BASE_URL + `/zw-information/articleMeetingMember/form/${goodsId}`,
      { goodsId },
      false
    );
  },
  // 手机号验证
  phoneValidate(data) {
    return zwitCore.HTTP.get(BASE_URL + "/zw-public/sms/validate", data, false);
  },
};
